module.exports = __webpack_public_path__ + "static/media/4_talking.29f6c471.jpg";